import React, { useRef, useState } from "react";
import AuthLayout from "./layout";
import { Link, useNavigate } from "react-router-dom";
import { URLS, APIS } from "../../_config";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Error from "../../components/formFieldError";
import Icon from "../../components/icons";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "../../_config/site_urls";
import { useUserApi } from "../../store/api/hooks/userApiHook";
import { useMasterApi } from "../../store/api/hooks/masterApiHook";

const Registration: React.FC = () => {
  const userApi: any = useUserApi();
  const masterAPI: any = useMasterApi();

  const navigate = useNavigate();
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const [selectedOption, setSelectedOption] = React.useState("");
  const [captchaValue, setCaptchaValue] = useState(null);
  const [company, setCompany] = useState([]);

  const recaptchaRef = useRef<ReCAPTCHA | null>(null);

  const handleRadioChange = (event: any) => {
    setSelectedOption(event.target.value);
  };
  const handleCaptchaChange = (value: any) => {
    setCaptchaValue(value);
  };

  const submitRegister = (params: any) => {
    return new Promise((resolve, reject) => {
      if (captchaValue) {
        userApi.register(
          params,
          (msg: any, resp: any) => {
            resolve(msg);
            let resetValues = { name: "", email: "", message: "", phone: "" };
            reset(resetValues);
          },
          (msg: any) => {
            // Handle error

            reject(msg);
          }
        );
        // fetch(APIS.AUTH.REGISTRATION, {
        //   method: "POST",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify(params),
        // })
        //   .then((response) => response.json())
        //   .then((resp) => {
        //     if (resp?.status == 200) {
        //       console.log("==msg==", resp);
        //       resolve(resp.message);
        //       let resetValues = { name: "", email: "", message: "" };
        //       reset(resetValues);
        //       // Reset reCAPTCHA
        //     } else {
        //       console.log("==errormsg==", resp);

        //       reject(resp.message);
        //     }
        //   })
        //   .catch((error) => {
        //     console.log("====xxyz===", error);
        //     toast.error(error.message);
        //     // Handle error
        //     console.error("Error:", error);
        //     reject(error.message);
        //   });
      } else {
        reject("Please verify the captcha.");
      }
    });
  };

  const saubmitFormHandler = (data: any) => {
    toast.promise(submitRegister(data), {
      loading: "Submitting...",
      success: (msg: any) => {
        navigate(URLS.LOGIN);
        return <b>{msg}</b>;
      },
      error: (msg: any) => <b>{msg}</b>,
    });
  };
  const handleToGetRadioChange = (event: any) => {
    const id = event.target.value;
    fetchData(id);
  };
  const fetchData = (id: any) => {
    masterAPI.getCompanyList(
      { type: id },
      (msg: any, resp: any) => {
        setCompany(resp.data.list);
        console.log("=====ooooo=====", resp.data.list);
      },
      (msg: any) => {
        console.log("msg==========", msg);
      }
    );
  };
  return (
    <AuthLayout>
      <div className="login_logo">
        <a href="javascript:void(0);">
          <img src="assets/images/login/logo.png" />
        </a>
      </div>
      <h3>Sign Up to Mortgage Support.</h3>
      <p>Enter your acount details please</p>
      <form onSubmit={handleSubmit(saubmitFormHandler)}>
        <div className="auth-sub-heading mb-2">
          <h4>Account type</h4>
        </div>
        <div className="auth-radio-options">
          <div className="d-flex align-items-center gap-15 mb-3">
            <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
              <input
                type="radio"
                id="customRadiocolor1bc"
                name="customRadiocolor1bc"
                className="custom-control-input"
                value="option1"
                checked={selectedOption === "option1"}
                onChange={handleRadioChange}
              />
              <label
                className="custom-control-label"
                htmlFor="customRadiocolor1bc"
              >
                Loan Officer/Processor
              </label>
            </div>
            <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
              <input
                type="radio"
                id="customRadiocolor2bd"
                name="customRadiocolor1bc"
                className="custom-control-input"
                value="option2"
                checked={selectedOption === "option2"}
                onChange={handleRadioChange}
              />
              <label
                className="custom-control-label"
                htmlFor="customRadiocolor2bd"
              >
                Lender/Vendor
              </label>
            </div>
          </div>
        </div>
        <div className="form-group mb-3">
          <Controller
            defaultValue={""}
            control={control}
            name="full_name"
            rules={{ required: "Full Name is required" }}
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
              <input
                type="text"
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                className="form-control"
                placeholder="Enter Your Full Name"
              />
            )}
          />
          <span className="input_icon">
            <img src="assets/images/login/user-svgrepo-com.svg" />
          </span>
          <Error error={errors["full_name"]} />
        </div>
        <div className="form-group mb-3">
          <Controller
            defaultValue={""}
            control={control}
            name="email"
            rules={{
              required: "Email is required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "Invalid email address",
              },
            }}
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
              <input
                type="text"
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                className="form-control"
                placeholder="Enter Your Email Id"
              />
            )}
          />
          <span className="input_icon">
            <img src="assets/images/login/New Letter.svg" />
          </span>
          <Error error={errors["email"]} />
        </div>

        <div className="form-group mb-3">
          <Controller
            defaultValue={""}
            control={control}
            name="phone"
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
              <input
                type="number"
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                className="form-control"
                placeholder="Enter Phone Number"
              />
            )}
          />
          <span className="input_icon">
            <img src="assets/images/login/phone_1.svg" />
          </span>
        </div>

        <div className="form-group mb-3">
          <Controller
            defaultValue={""}
            control={control}
            name="password"
            rules={{
              required: "Password is required",

              minLength: {
                value: 6,
                message: "Password must have at least 6 characters",
              },
              maxLength: {
                value: 16,
                message: "must be less than 16 characters in length",
              },
              pattern: {
                value:
                  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
                message:
                  "Must contain uppercase, lowercase, number, and special character",
              },
            }}
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
              <input
                type={showPassword ? "text" : "password"}
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                className="form-control"
                placeholder="Enter your Password"
              />
            )}
          />
          <span className="input_icon">
            <Icon
              name={showPassword ? "eye" : "eye-off"}
              onClick={() => setShowPassword(!showPassword)}
            />{" "}
          </span>
          <Error error={errors["password"]} />
        </div>
        <div className="form-group mb-3">
          <Controller
            defaultValue={""}
            control={control}
            name="confirm_password"
            rules={{
              required: "Confirm Password is required",
              minLength: {
                value: 6,
                message: "Password must have at least 6 characters",
              },
            }}
            // rules={{ required: 'Confirm Password is required', validate: (value) => value === control.getValues('password') || 'The passwords do not match' }}
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
              <input
                type={showConfirmPassword ? "text" : "password"}
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                className="form-control"
                placeholder="Enter your confirm password"
              />
            )}
          />
          <span className="input_icon">
            <Icon
              name={showConfirmPassword ? "eye" : "eye-off"}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            />{" "}
          </span>
          <Error error={errors["confirm_password"]} />
        </div>

        <div className="auth-sub-heading mb-2">
          <h4>I am a ...</h4>
        </div>
        {selectedOption == "option1" && (
          <div id="option1">
            <div className="auth-radio-options">
              <div className="d-flex align-items-center gap-15 mb-3">
                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                  <Controller
                    defaultValue={""}
                    control={control}
                    name="role"
                   
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                    }) => (
                      <input
                        type="radio"
                        id="customRadiocolor1b"
                        name={name}
                        onChange={onChange}
                        className="custom-control-input"
                        value="loan-officer"
                      />
                    )}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customRadiocolor1b"
                  >
                    Loan Officer
                  </label>
                </div>
                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                  <Controller
                    defaultValue={""}
                    control={control}
                    name="role"
                  
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                    }) => (
                      <input
                        type="radio"
                        id="customRadiocolor1b"
                        name={name}
                        onChange={onChange}
                        className="custom-control-input"
                        value="processer"
                      />
                    )}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customRadiocolor2b"
                  >
                    Processer
                  </label>
                </div>
              </div>
            </div>
          
          </div>
        )}

        {selectedOption == "option2" && (
          <div id="option2">
            <div className="auth-radio-options">
              <div className="d-flex align-items-center gap-15 mb-3">
                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                  <Controller
                    defaultValue={""}
                    control={control}
                    name="role"
                  
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                    }) => (
                      <input
                        type="radio"
                        id="customRadiocolor1b"
                        name={name}
                        onChange={(e) => {
                          onChange(handleToGetRadioChange(e));
                          console.log("Changed to:", e.target.value);
                        }}
                        className="custom-control-input"
                        value="lender"
                      />
                    )}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customRadiocolor1b"
                  >
                    Lender
                  </label>
                </div>
                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                  <Controller
                    defaultValue={""}
                    control={control}
                    name="role"
                 
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                    }) => (
                      <input
                        type="radio"
                        id="customRadiocolor1b"
                        name={name}
                        onChange={(e) => {
                          onChange(handleToGetRadioChange(e));
                          console.log("Changed to:", e.target.value);
                        }}
                        className="custom-control-input"
                        value="vendor"
                      />
                    )}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customRadiocolor2b"
                  >
                    Vendor
                  </label>
                </div>
              </div>
            </div>
            {company && company.length > 0 && (
              <div className="form-group">
                <Controller
        name="category_id"
        control={control}
        defaultValue=""
        render={({ field }) => (
                <select {...field} id="formrow-inputState" className="form-control">
                  <option selected>-Please Select Your Company-</option>
                  {company &&
                    company.length > 0 &&
                    company.map((val: any, item: any) => {
                      return (
                        <option key={item} value={val.id}>
                          {val.name}
                        </option>
                      );
                    })}
                </select>
)}
/>
                
              </div>
            )}
          </div>
        )}
        {/* <div className="form-group mb-2 d-flex gap-2">
                <Controller
                    defaultValue={""}
                    control={control}
                    name="terms_and_condition"
                    rules={{ required: 'You confirm that you accept the terms and conditions & privacy policy' }}
                    render={({
                        field: { onChange, onBlur, value, name, ref },
                    }) => (
                        <input type="checkbox" name={name} onChange={onChange} onBlur={onBlur} value={value} />
                    )}
                />
                <span><Link to={'#'}>By clicking on 'Register' below, you confirm that you accept the terms and conditions & privacy policy</Link></span>
            </div> */}
        <div className="pb-2">
          <div className="custom-control custom-checkbox custom-checkbox-lg  custom-checkbox-primary mb-3 d-flex align-items-center">
            <input
              type="checkbox"
              className="custom-control-input"
              id="customCheckcolor2"
            />
            <label
              className="custom-control-label pt-0"
              htmlFor="customCheckcolor2"
            >
              I accept <a href="#">Terms</a> and <a href="#">Privacy Policy</a>{" "}
              for more details.
            </label>
          </div>
        </div>
        <div className="notrobot">
          <div className="captcha">
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              ref={recaptchaRef}
              onChange={handleCaptchaChange}
            />
          </div>
        </div>
        <div>
          <Error error={errors["terms_and_condition"]} />
        </div>
        <button className="loginBtn">Register</button>
        <div className="create_account">
          Already have an account ? <Link to={URLS.LOGIN}>Login</Link>
        </div>
      </form>
      <div className="login_copyright">
        © <script>document.write(new Date().getFullYear())</script> Mortgage
        Support | <a href="javascript:void(0);"> Policy</a> |{" "}
        <a href="javascript:void(0);"> Terms</a>
      </div>
    </AuthLayout>
  );
};

export default Registration;
